/* Crafted Series redesign — shared behaviour (AJAX cart, finder, PDP, reveal, mobile menu) */
(function(){
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $(s,c){return (c||document).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}

  /* ---------- cart count ---------- */
  function setCount(n){ $$('[data-cs-cart-count]').forEach(function(el){ el.textContent=n; el.style.display=n?'grid':'none'; }); }
  function refreshCount(){ fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()}).then(function(c){setCount(c.item_count)}).catch(function(){}); }

  /* ---------- toast ---------- */
  var toastT;
  function toast(title, sub, isError){
    var t=$('.cs-toast');
    if(!t){ var w=document.createElement('div'); w.className='cs'; w.innerHTML='<div class="cs-toast" role="status" aria-live="polite"></div>'; document.body.appendChild(w); t=$('.cs-toast',w); }
    t.innerHTML='<div><b></b><br><small></small></div>'+(isError?'':'<a href="'+root+'cart">Checkout →</a>');
    t.querySelector('b').textContent=title; t.querySelector('small').textContent=sub||'';
    t.classList.add('cs-show'); clearTimeout(toastT); toastT=setTimeout(function(){t.classList.remove('cs-show')},3800);
  }

  /* ---------- AJAX add to cart: any form[data-cs-ajax] posting to /cart/add ---------- */
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f.matches || !f.matches('form[data-cs-ajax]')) return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'); if(btn){btn.disabled=true;}
    fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok){ toast('Could not add to cart', res.j.description||res.j.message||'', true); return; }
        var item=res.j.items?res.j.items[0]:res.j;
        refreshCount();
        if($('[data-cs-cart-drawer]')){ refreshCart().then(function(){ openCart(); }); }
        else toast(f.getAttribute('data-cs-added')||'Added to cart', item.product_title||'');
        document.dispatchEvent(new CustomEvent('cs:cart:added',{detail:item}));
      })
      .catch(function(){ f.submit(); })
      .finally(function(){ if(btn) btn.disabled=false; });
  });


  /* ---------- cart drawer + cart page ---------- */
  function regions(){ return $$('[data-cs-cart-region]'); }
  function applySections(html){
    regions().forEach(function(r){
      var id=r.getAttribute('data-section'); if(!html[id]) return;
      var doc=new DOMParser().parseFromString(html[id],'text/html');
      var fresh=doc.querySelector('[data-cs-cart-region]');
      if(fresh) r.innerHTML=fresh.innerHTML;
    });
    var body=$('[data-cs-cart-body]'); var n=body?+body.getAttribute('data-count'):0;
    $$('[data-cs-cart-foot]').forEach(function(f){ f.hidden=!n; });
    var h=$('.cs-cart-head .cs-h3'); if(h) h.innerHTML='Your cart'+(n?' <span>('+n+')</span>':'');
    setCount(n);
  }
  function sectionIds(){ return regions().map(function(r){return r.getAttribute('data-section')}).filter(Boolean); }
  function refreshCart(){
    var ids=sectionIds(); if(!ids.length) return Promise.resolve();
    return fetch(root+'?sections='+ids.join(',')).then(function(r){return r.json()}).then(applySections).catch(function(){});
  }
  var lastFocus;
  function openCart(){ var d=$('[data-cs-cart-drawer]'); if(!d) return; lastFocus=document.activeElement; d.classList.add('cs-open'); d.setAttribute('aria-hidden','false'); document.documentElement.classList.add('cs-lock'); var c=$('[data-cs-cart-close].cs-icon-btn',d); if(c) c.focus(); }
  function closeCart(){ var d=$('[data-cs-cart-drawer]'); if(!d) return; d.classList.remove('cs-open'); d.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('cs-lock'); if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
  document.addEventListener('click',function(e){
    var o=e.target.closest('[data-cs-cart-open]');
    if(o && $('[data-cs-cart-drawer]') && !/\/cart\/?$/.test(location.pathname)){ e.preventDefault(); refreshCart(); openCart(); return; }
    if(e.target.closest('[data-cs-cart-close]')){ closeCart(); return; }
    var q=e.target.closest('[data-cs-q]');
    if(q){
      var line=q.closest('[data-key]'); if(!line) return;
      line.classList.add('cs-busy');
      fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.getAttribute('data-key'),quantity:+q.getAttribute('data-cs-q'),sections:sectionIds()})})
        .then(function(r){return r.json()}).then(function(j){ if(j.sections) applySections(j.sections); else refreshCart(); if(j.status && j.description) toast('Could not update cart', j.description, true); })
        .catch(function(){ location.reload(); });
    }
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeCart(); });


  /* ---------- predictive search ---------- */
  function initSearch(form){
    var input=$('input[type=search]',form); if(!input||form.__cs) return; form.__cs=1;
    form.style.position=form.style.position||'relative';
    var box=document.createElement('div'); box.className='cs-suggest'; box.hidden=true; box.setAttribute('role','listbox'); form.appendChild(box);
    var t,ctrl;
    function esc(x){return String(x==null?'':x).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
    input.setAttribute('autocomplete','off');
    input.addEventListener('input',function(){
      clearTimeout(t); var q=input.value.trim(); if(q.length<2){box.hidden=true;return;}
      t=setTimeout(function(){
        if(ctrl) ctrl.abort(); ctrl=window.AbortController?new AbortController():null;
        fetch(root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag',ctrl?{signal:ctrl.signal}:{})
          .then(function(r){return r.json()}).then(function(j){
            var r=(j.resources||{}).results||{}, ps=r.products||[], cs=r.collections||[];
            if(!ps.length&&!cs.length){ box.innerHTML='<p class="cs-suggest-empty">No matches. Press Enter to search everything.</p>'; box.hidden=false; return; }
            var h='';
            if(cs.length) h+='<p class="cs-suggest-h">Collections</p>'+cs.slice(0,3).map(function(c){return '<a class="cs-suggest-c" href="'+esc(c.url)+'">'+esc(c.title)+'</a>'}).join('');
            if(ps.length) h+='<p class="cs-suggest-h">Products</p>'+ps.map(function(p){return '<a class="cs-suggest-p" href="'+esc(p.url)+'">'+(p.image?'<img src="'+esc(p.image)+(p.image.indexOf('?')>-1?'&':'?')+'width=96" alt="" loading="lazy">':'<span></span>')+'<span><b>'+esc(p.title)+'</b><small>'+esc(p.price?('$'+(+p.price).toFixed(2)):'')+'</small></span></a>'}).join('');
            h+='<button type="submit" class="cs-suggest-all">See all results for “'+esc(q)+'”</button>';
            box.innerHTML=h; box.hidden=false;
          }).catch(function(){});
      },180);
    });
    document.addEventListener('click',function(e){ if(!form.contains(e.target)) box.hidden=true; });
    input.addEventListener('keydown',function(e){ if(e.key==='Escape') box.hidden=true; });
  }

  /* ---------- kit finder ---------- */
  function initFinder(el){
    var color=el.getAttribute('data-default-color')||'Red', body=el.getAttribute('data-default-body')||'medium';
    var max=parseInt(el.getAttribute('data-max')||'6',10);
    var cards=$$('[data-cs-kit]',el), title=$('[data-cs-f-title]',el), count=$('[data-cs-f-count]',el), empty=$('[data-cs-f-empty]',el), all=$('[data-cs-f-all]',el);
    function render(){
      var shown=0, total=0;
      cards.forEach(function(c){
        var ok=(c.getAttribute('data-finder-body')||c.getAttribute('data-body'))===body && (color==='any'||c.getAttribute('data-color')===color);
        if(ok) total++;
        c.hidden=!(ok && shown<max); if(ok && shown<max) shown++;
      });
      var bOpt=$('[data-cs-body][data-v="'+body+'"]',el), cOpt=$('[data-cs-color][data-v="'+color+'"]',el);
      if(title) title.textContent=(bOpt?bOpt.getAttribute('data-label'):'')+' '+(cOpt?cOpt.getAttribute('data-plural'):'');
      if(count) count.textContent= total? total+' kit'+(total>1?'s':'')+(bOpt?' · '+bOpt.getAttribute('data-abv')+' ABV':'') : '';
      if(empty) empty.hidden= total>0;
      if(all && bOpt){ all.href=bOpt.getAttribute('data-url'); }
    }
    el.addEventListener('click',function(e){
      var c=e.target.closest('[data-cs-color]'), b=e.target.closest('[data-cs-body]');
      if(c){ color=c.getAttribute('data-v'); $$('[data-cs-color]',el).forEach(function(x){x.setAttribute('aria-pressed',x===c)}); render(); }
      if(b){ body=b.getAttribute('data-v'); $$('[data-cs-body]',el).forEach(function(x){x.setAttribute('aria-pressed',x===b)}); render(); }
    });
    render();
  }

  /* ---------- PDP: variant radios, qty, sticky bar ---------- */
  function money(cents){ var f=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'; try{return new Intl.NumberFormat(undefined,{style:'currency',currency:f}).format(cents/100)}catch(e){return '$'+(cents/100).toFixed(2)} }
  function initPdp(el){
    var dataEl=$('[data-cs-variants]',el); var variants=dataEl?JSON.parse(dataEl.textContent):[];
    var bottles=parseInt(el.getAttribute('data-bottles')||'0',10);
    /* Fix 2026-10-14: target the add-to-cart form's id input, not the first one on the page (Shop Pay installments form came first, so the cart always got variant #1) */
    var idInput=$('form[data-cs-ajax] input[name=id]',el)||$('input[name=id]',el), priceEl=$('[data-cs-price]',el), pbEl=$('[data-cs-pb]',el), atc=$$('[data-cs-atc]',el), sPrice=$('[data-cs-s-price]');
    function sel(){
      var opts=$$('[data-cs-option]',el).map(function(g){var c=$('input:checked',g);return c?c.value:null});
      var v=variants.filter(function(v){return v.options.every(function(o,i){return opts[i]==null||o===opts[i]})})[0];
      if(!v) return;
      idInput.value=v.id;
      $$('input[name=id]',el).forEach(function(i){ i.value=v.id; }); /* keep installments form in sync */
      var save=v.compare_at_price>v.price?Math.round((1-v.price/v.compare_at_price)*100):0;
      if(priceEl) priceEl.innerHTML='<b>'+money(v.price)+'</b>'+(save?'<s>'+money(v.compare_at_price)+'</s><span class="cs-save">Save '+save+'%</span>':'');
      if(pbEl && bottles) pbEl.textContent=money(Math.round(v.price/bottles))+' / bottle';
      if(sPrice) sPrice.textContent=money(v.price);
      atc.forEach(function(b){ b.disabled=!v.available; b.textContent=v.available?(b.getAttribute('data-label')||'Add to cart'):(b.getAttribute('data-soldout')||'Sold out'); });
      if(v.featured_media && v.featured_media.preview_image){ showMedia(v.featured_media.id, v.featured_media.preview_image.src, v.featured_media.alt); }
      if(history.replaceState){ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState({},'',u); }
    }
    function showMedia(id, src, alt){
      var img=$('.cs-gallery-main img',el.closest('.cs-pdp')||document); if(!img) return;
      var t=$('.cs-thumbs [data-media-id="'+id+'"]',el.closest('.cs-pdp')||document);
      var big=t?t.getAttribute('data-src'):(src+(src.indexOf('?')>-1?'&':'?')+'width=1100');
      if(img.getAttribute('src')!==big){ img.removeAttribute('srcset'); img.src=big; if(alt) img.alt=alt; }
      $$('.cs-thumbs button',el.closest('.cs-pdp')||document).forEach(function(b){ b.setAttribute('aria-current', b===t?'true':'false'); });
      if(t && t.scrollIntoView && t.parentNode.scrollWidth>t.parentNode.clientWidth){ t.parentNode.scrollLeft=t.offsetLeft-t.parentNode.offsetLeft-8; }
    }
    /* thumb click selects the matching variant's options (e.g. colour) */
    $$('.cs-thumbs button',el.closest('.cs-pdp')||document).forEach(function(b){
      b.addEventListener('click',function(){
        var mid=parseInt(b.getAttribute('data-media-id'),10);
        var cur=variants.filter(function(v){return String(v.id)===String(idInput.value)})[0];
        var cands=variants.filter(function(v){return v.featured_media && v.featured_media.id===mid});
        if(!cands.length) return;
        var pick=cands.filter(function(v){ return cur && v.options.slice(1).join('|')===cur.options.slice(1).join('|'); })[0]||cands[0];
        var groups=$$('[data-cs-option]',el);
        pick.options.forEach(function(o,i){ var g=groups[i]; if(!g) return; $$('input',g).forEach(function(r){ if(r.value===o) r.checked=true; }); });
        sel();
      });
    });
    el.addEventListener('change',function(e){ if(e.target.closest('[data-cs-option]')) sel(); });
    var q=$('[data-cs-qty]',el);
    if(q){ $('[data-cs-qm]',el).addEventListener('click',function(){q.value=Math.max(1,(+q.value||1)-1)}); $('[data-cs-qp]',el).addEventListener('click',function(){q.value=(+q.value||1)+1}); }
    var sticky=$('.cs-sticky-atc'), main=$('[data-cs-main-atc]',el);
    if(sticky && main && 'IntersectionObserver' in window){
      new IntersectionObserver(function(es){ sticky.classList.toggle('cs-show', !es[0].isIntersecting && es[0].boundingClientRect.top<0); }).observe(main);
      var sb=$('[data-cs-s-atc]',sticky); if(sb) sb.addEventListener('click',function(){ var f=$('form[data-cs-ajax]',el); if(f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true})); });
    }
  }

  /* ---------- collection filters (mobile toggle + auto-submit) ---------- */
  function initCollection(el){
    var t=$('[data-cs-filter-toggle]',el), f=$('.cs-filters',el);
    if(t&&f) t.addEventListener('click',function(){ f.classList.toggle('cs-open'); t.setAttribute('aria-expanded',f.classList.contains('cs-open')); });
    $$('form[data-cs-autosubmit]',el).forEach(function(form){ form.addEventListener('change',function(){ form.submit(); }); });
  }

  /* ---------- mobile menu ---------- */
  function initMenu(){
    var d=$('[data-cs-drawer]'); if(!d) return;
    $$('[data-cs-menu-open]').forEach(function(b){ b.addEventListener('click',function(){ d.classList.add('cs-open'); b.setAttribute('aria-expanded','true'); }); });
    $$('[data-cs-menu-close]',d).forEach(function(b){ b.addEventListener('click',function(){ d.classList.remove('cs-open'); $$('[data-cs-menu-open]').forEach(function(x){x.setAttribute('aria-expanded','false')}); }); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') d.classList.remove('cs-open'); });
  }

  function reveal(scope){
    var els=$$('.cs-reveal:not(.cs-in)',scope);
    if(!('IntersectionObserver' in window) || window.Shopify && Shopify.designMode){ els.forEach(function(e){e.classList.add('cs-in')}); return; }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('cs-in');io.unobserve(e.target)}})},{threshold:.12});
    els.forEach(function(e){io.observe(e)});
  }

  function init(scope){
    $$('[data-cs-finder]',scope).forEach(initFinder);
    $$('[data-cs-pdp]',scope).forEach(initPdp);
    $$('[data-cs-collection]',scope).forEach(initCollection);
    $$('.cs form[role=search]',scope).forEach(initSearch);
    reveal(scope);
  }
  document.addEventListener('DOMContentLoaded',function(){ init(document); initMenu(); });
  /* Theme Editor: re-init sections when they're added/edited */
  document.addEventListener('shopify:section:load',function(e){ init(e.target); initMenu(); });
})();
